var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSaturniaStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20.94 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_2",
    "data-name": "Camada 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "wpp"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.28.51,14,6.06l6.14.9a.9.9,0,0,1,.5,1.54l-4.44,4.33,1.05,6.11a.91.91,0,0,1-1.32.95L10.47,17,5,19.89a.9.9,0,0,1-1.31-.95l1-6.11L.27,8.5A.9.9,0,0,1,.78,7l6.13-.9L9.65.51A.91.91,0,0,1,11.28.51Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaturniaStar);
export default __webpack_public_path__ + "static/media/saturnia-star.cd5fe66a0007ed1e9dad0a389929b0a9.svg";
export { ForwardRef as ReactComponent };